import Header from "./Header";
import Footer from "./Footer";
import Other from "./Other";
import SidebarCenter from "./SidebarCenter";
import SidebarTop from "./SidebarTop";
import SidebarBottom from "./SidebarBottom";

const layoutsComponents = {
  Header,
  Footer,
  Other,
  SidebarCenter,
  SidebarTop,
  SidebarBottom
}

export default layoutsComponents